module.exports = __webpack_public_path__ + "img/unity-package-manager2.190d0964.png";